// extracted by mini-css-extract-plugin
export var icon = "_45-3";
export var subtitle = "_45-2";
export var title = "_45-1";
export var value = "_45-0";